import styled from 'styled-components';
import { color } from 'styles/colors';

export const container = styled.div`
  width: 100%;
  display: flex;
  background-color: white;
  align-items: center;
  justify-content: center;
  border-radius: 5px;
  padding: 10px;
`;

export const containerItens = styled.div`
  width: 100%;
  gap: 10px;
  display: flex;
  overflow: auto;
  ::-webkit-scrollbar {
    display: none;
  }

  scrollbar-width: none;
`;

export const item = styled.div`
  min-width: 70px;
  display: grid;
  grid-template-rows: 1fr 0.3fr;
  overflow: hidden;
  /* background-color: blue; */

  > p {
    height: 100%;
    /* background-color: red; */
    text-align: center;
    font-size: 10px;
    color: ${color.interface.darkgray};
    font-weight: 900;
    white-space: nowrap;
    /* white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis; */
  }

  > img {
    /* background-color: yellow; */
    width: 100%;
    height: 100%;
    border-radius: 50%;
  }
`;

export const noItens = styled.div`
  width: 100%;
  align-items: center;
  justify-content: center;

  > p {
    font-size: 30px;
    color: gray;
  }
`;
